module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Don Reardon is a highly skilled artist and craftsman, proficient in the creation of fired clay sculpture. Over the years, he has created many of his own clay formulas that better serve a more quality sculpture. The same quest for improving his work applies to paintings on wood and canvas as well as the creation of rustic furniture.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Don is from North Carolina. After serving in the United States Army for three years, he acquired a formal education in advertising and marketing and has travelled throughout the United States.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Due to the seclusion of people caused by the pandemic, Don’s creative lifestyle has adapted, and he has written his first novel—no less exciting, a bit more challenging, however. He continues to ramble through the woods, fish in the creek, enjoying nature, finding things, deer antler, turtle shell, owl feather. Nature has an uncanny way of communicating. Oftentimes, the answer is hiding in plain sight.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Writing reaches out to Don. Creating with words just as he does with clay, paint, wood—all tell a story. He knows when he has created a character it will be real and quickly take its place among other characters in a story. Full-blown emotions reaching down to their inner selves, perceptions, very real, prejudices, hate—all becoming part of characters Don creates.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_c('em', [_vm._v("Passion of Kin")]), _vm._v(" is based on true life events and memories, many events experienced through the eyes of Don as a little boy. Other characters are based on real people in his life sharing their traumas and experiences.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Don believes his readers will enjoy coming along for the journey.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0